import React, { useState } from 'react'
import ButterToast, { Cinnamon } from 'butter-toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'
import { setPosting, setPosted } from '../App'
import { DefaultLatePolicyForm } from './DefaultLatePolicyForm'
import { ItemsSelected } from '../base_comps/ItemsSelected'

export const SelectedAssessmentsContainer = () => {
  const [currentState, dispatch] = useStateValue()
  const [currentAct, setCurrentAct] = useState(0)
  let params = window.location.pathname.split('/')
  let coursenum = params[3]
  let contextId = params[4]

  const postSelectedAssessments = async (
    selectedAsmts,
    contextId,
    coursenum,
    setPosting,
    setPosted,
    dispatch,
    useNewTab=true
  ) => {
    setPosting(true, dispatch)

    selectedAsmts.sort(function (a, b) {
      if (a.groupSortOrder === b.groupSortOrder) {
        return a.sortOrder - b.sortOrder
      }
      return a.groupSortOrder > b.groupSortOrder ? 1 : -1
    })

    for (let i = 0; i < selectedAsmts.length; i++) {
      let data = {
        contextId: contextId,
        selectedAssessments: [selectedAsmts[i]],
        useNewTab: useNewTab
      }
      try {
        setCurrentAct(i + 1)
        await client.post(endpoints.postAssessments(), data)
      } catch (err) {
        console.log(err)
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title="Error"
              content={
                'There was an error configuring the deep links in Canvas.'
              }
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-thumbs-down fa-3x" />}
            />
          ),
        })
      }
    }

    try {
      let resp = await client.get(
        endpoints.getAssessments({
          coursenum: coursenum,
          contextId: contextId,
        })
      )
      dispatch({
        type: 'assessmentGroups',
        assessmentGroups: resp.data.assessmentGroups,
      })
    } catch (err) {
      setPosted(true, dispatch)
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    }
    setPosted(true, dispatch)
    setPosting(false, dispatch)
  }

  const resetSelected = (dispatch, setPosted) => {
    dispatch({
      type: 'assessmentGroupSelection',
      selectedAssessments: [],
    })
    setPosted(false, dispatch)
  }

  return (
    <React.Fragment>
      <div className="mb-4">
        <ItemsSelected
          items={currentState.selectedAssessments}
          currentItem={currentAct}
          contentCategory="Assessment"
          contentType="assessment"
          postItems={postSelectedAssessments}
          postParams={[
            currentState.selectedAssessments,
            contextId,
            coursenum,
            setPosting,
            setPosted,
            dispatch,
          ]}
          resetFunc={resetSelected}
          resetParams={[dispatch, setPosted]}
          posting={currentState.linksPosting}
          posted={currentState.linksPosted}
        />
      </div>
      <DefaultLatePolicyForm />
    </React.Fragment>
  )
}
